import { array } from 'fp-ts';
import { pipe } from 'fp-ts/function';
import { ResourceFeature } from '@mews-commander/resources';

interface OwnProps {
    features: Array<ResourceFeature>;
}

export const ResourceFeatureList = ({ features }: OwnProps) => (
    <span>
        {pipe(
            features,
            array.map((f) => f.name),
            (names) => names.join(', ')
        )}
    </span>
);
